// import { Avatar,Icon } from "@windmill/react-ui";
import Avatar from "@mui/material/Avatar";
import { blue } from "@material-ui/core/colors";
import React, { useEffect, useState } from "react";
import { IoNotifications } from "react-icons/io5";
import { IoSunnySharp } from "react-icons/io5";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LogoutIcon from "@mui/icons-material/Logout";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import useLogout from "../hooks/useLogout";
import { useNavigate } from "react-router-dom";
import CountrySwitch from "./utils/CountrySwitch";
import hamburger from "../assets/img/hamuburgen.svg";
import HamburgerMenu from "./utils/HamburgerMenu";
import useAuthStore from "../store/UserStore";

const Header = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { logout } = useLogout();
    const navigate = useNavigate();
    const country = useAuthStore((state) => state.country);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        // Handle logout logic
        handleClose();
    };

    const handleEditAccount = () => {
        // Handle edit account logic
        navigate("/edit-profile");
        handleClose();
    };

    const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);

    const handleOpenHamburgerMenu = () => {
        setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
    };

    return (
        <div className=" py-3 bg-gray-800" style={{ alignItems: "center" }}>
            <div className="h-full flex gap-4 justify-end items-center px-6 md:justify-between">
                <div className="hidden md:block">
                    <div className="w-[40px] cursor-pointer" onClick={handleOpenHamburgerMenu}>
                        <img
                            src={hamburger}
                            className="block w-[100%] filter invert"
                            alt="hamburger icon"
                        />
                    </div>
                </div>

                <div className="relative py-2 flex gap-10">
                    <CountrySwitch onSwitch={(e) => useAuthStore.getState().changeCountry()} />
                    <Avatar sx={{ bgcolor: "blue", cursor: "pointer" }} onClick={handleClick}>
                        A
                    </Avatar>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                    >
                        <MenuItem onClick={handleEditAccount}>
                            <DriveFileRenameOutlineIcon />
                            Edit Account
                        </MenuItem>
                        <MenuItem onClick={logout}>
                            <LogoutIcon /> Logout
                        </MenuItem>
                    </Menu>
                </div>
            </div>
            {/* {isMenuOpen && (
                <div
                    className={`fixed top-0 right-0 h-full w-[300px] bg-gray-800 text-white transform ${
                        isMenuOpen ? "translate-x-0" : "translate-x-full"
                    } transition-transform duration-700 ease-in-out z-40`}
                > */}
            <HamburgerMenu
                isHamburgerMenuOpen={isHamburgerMenuOpen}
                handleOpenHamburgerMenu={handleOpenHamburgerMenu}
            />
            {/* </div>
            )} */}
        </div>
    );
};

export default Header;
